import { TrendingUp } from "react-feather";
import { Card, CardBody } from "reactstrap";
import { CommonCurrencyWidgetPropsType } from "../../../Type/WidgetsType";
import { H5 } from "../../../AbstractElements";
import CurrencyWidgetChart from "./CurrencyWidgetChart";

const CurrencyWidgetCard = ({ data }: CommonCurrencyWidgetPropsType) => {
  return (
    <Card>
      <CardBody className="d-flex">
        <div className="currency-chart-wrap">
          <CurrencyWidgetChart chartData={data.chart} />
        </div>
        <div className={`bg-light-${data.color} text-center`}>
          <H5 className="mb-sm-0">${data.price}</H5>
          <span className={`f-12 f-w-500 font-${data.color}`}>
            <TrendingUp className="me-1" />+{data.gros}%
          </span>
        </div>
      </CardBody>
    </Card>
  );
};

export default CurrencyWidgetCard;
